import { Slider } from "../ui/slider";

export const EMPTY_FILTERS = { types: [], genders: [], sizes: [], colors: [], maxPrice: null };
const TYPES = { "t-shirt": "T-Shirts", hat: "Hats", hoodie: "Hoodies", "tank-top": "Tank Tops" };
const GENDERS = { men: "Men", women: "Women", unisex: "Unisex" };

export const applyFilters = (list, f) =>
  list.filter(
    (p) =>
      (!f.types.length || f.types.includes(p.product_type)) &&
      (!f.genders.length || f.genders.includes(p.gender)) &&
      (!f.sizes.length || p.sizes.some((s) => f.sizes.includes(s))) &&
      (!f.colors.length || p.colors.some((c) => f.colors.includes(c.name))) &&
      (f.maxPrice == null || p.price <= f.maxPrice)
  );

const Chip = ({ on, children, ...p }) => (
  <button
    className={`px-3.5 h-10 rounded-full text-sm font-semibold border-2 transition-colors ${on ? "bg-navy border-navy text-white" : "border-border text-navy hover:border-navy"}`}
    aria-pressed={on}
    {...p}
  >
    {children}
  </button>
);

const Group = ({ title, children }) => (
  <div className="py-5 border-b border-border first:pt-0">
    <h4 className="text-xs font-extrabold uppercase tracking-widest text-navy/50 mb-3">{title}</h4>
    <div className="flex flex-wrap gap-2">{children}</div>
  </div>
);

export const Filters = ({ products, value, onChange }) => {
  const toggle = (k, v) => onChange({ ...value, [k]: value[k].includes(v) ? value[k].filter((x) => x !== v) : [...value[k], v] });
  const sizes = [...new Set(products.flatMap((p) => p.sizes))];
  const colors = [...new Map(products.flatMap((p) => p.colors).map((c) => [c.name, c])).values()];
  const max = Math.ceil(Math.max(...products.map((p) => p.price), 10));
  const cur = value.maxPrice ?? max;
  return (
    <div data-testid="filters-panel">
      <Group title="Product type">
        {Object.entries(TYPES).map(([k, v]) => (
          <Chip key={k} on={value.types.includes(k)} onClick={() => toggle("types", k)} data-testid={`filter-type-${k}`}>{v}</Chip>
        ))}
      </Group>
      <Group title="Fit">
        {Object.entries(GENDERS).map(([k, v]) => (
          <Chip key={k} on={value.genders.includes(k)} onClick={() => toggle("genders", k)} data-testid={`filter-gender-${k}`}>{v}</Chip>
        ))}
      </Group>
      <Group title="Size">
        {sizes.map((s) => (
          <Chip key={s} on={value.sizes.includes(s)} onClick={() => toggle("sizes", s)} data-testid={`filter-size-${s.toLowerCase().replace(/\s+/g, "-")}`}>{s}</Chip>
        ))}
      </Group>
      <Group title="Color">
        {colors.map((c) => (
          <button
            key={c.name}
            title={c.name}
            aria-label={c.name}
            aria-pressed={value.colors.includes(c.name)}
            onClick={() => toggle("colors", c.name)}
            className={`w-9 h-9 rounded-full border border-navy/20 ${value.colors.includes(c.name) ? "ring-2 ring-offset-2 ring-turq" : ""}`}
            style={{ background: c.hex }}
            data-testid={`filter-color-${c.name.toLowerCase().replace(/\s+/g, "-")}`}
          />
        ))}
      </Group>
      <div className="py-5">
        <h4 className="text-xs font-extrabold uppercase tracking-widest text-navy/50 mb-4">Max price · ${cur}</h4>
        <Slider min={10} max={max} step={1} value={[cur]} onValueChange={([v]) => onChange({ ...value, maxPrice: v })} data-testid="filter-price-slider" />
      </div>
    </div>
  );
};
